import { Button, Drawer, Grid, Typography, Box } from '@material-ui/core';
import { styled } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShowArchiveFilter, DateFilter, TypeFilter } from 'components/Events';
import { CardContent } from '@mui/material';
import PropTypes from 'prop-types';

const StyledGridForButton = styled(Grid)({
  padding: '10px 10px 10px 10px',
  marginTop: '10px',
});

const StyledGridForCardContent = styled(Grid)({
  padding: '0px 0px 0px 0px',
});

const StyledForCardContent = styled(CardContent)({
  padding: '0px 0px 0px 0px',
  '&.css-46bh2p-MuiCardContent-root': { paddingTop: 10 },
  '&.css-46bh2p-MuiCardContent-root:last-child': { paddingBottom: 10 },
});

const StyledForDrawer = styled(Drawer)({
  height: '100%',
  display: 'flex',
  '& ::-webkit-scrollbar': { display: 'none' },
  '& .MuiDrawer-paperAnchorBottom': {
    borderRadius: '10px 10px 0px 0px',

    maxHeight: '75%',
    height: 'auto',
  },
});

const EventsFilterMobile = ({ submitFilter, restoreDefaultFilters, isOpen, toggleFilter }) => {
  const { t } = useTranslation();

  return (
    <StyledForDrawer anchor={'bottom'} open={isOpen}>
      <Grid container direction="row" justifyContent="space-around">
        <Box>
          <StyledGridForCardContent item>
            <StyledForCardContent>
              <Typography variant="h2">{t('filters')}</Typography>
            </StyledForCardContent>
          </StyledGridForCardContent>
        </Box>
        <Box sx={{ marginBottom: 60, paddingLeft: 10 }}>
          <Grid container>
            <Grid item container xs={12} direction="row" sx={{ width: 'auto' }} justifyContent="space-evenly">
              <ShowArchiveFilter />
              <TypeFilter submitFilter={submitFilter} />
            </Grid>
            <Grid container>
              <DateFilter submitFilter={submitFilter} />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ position: 'fixed', bottom: 0, width: '100%', backgroundColor: '#FF', zIndex: 1220 }}>
          <Grid container padding={2} justifyContent="space-evenly">
            <StyledGridForButton item>
              <Button
                onClick={() => {
                  restoreDefaultFilters();
                }}
                color="primary"
                variant="contained"
                sx={{ flex: 1 }}
              >
                {t('clear')}
              </Button>
            </StyledGridForButton>
            <StyledGridForButton item>
              <Button
                onClick={() => {
                  toggleFilter();
                }}
                color="primary"
                variant="contained"
                sx={{ flex: 1 }}
              >
                {t('close')}
              </Button>
            </StyledGridForButton>
          </Grid>
        </Box>
      </Grid>
    </StyledForDrawer>
  );
};

EventsFilterMobile.propTypes = {
  submitFilter: PropTypes.func.isRequired,
  restoreDefaultFilters: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleFilter: PropTypes.func.isRequired,
};

EventsFilterMobile.defaultProps = {
  isOpen: false,
};

export default EventsFilterMobile;
